export default __webpack_public_path__ + "static/media/rocket_anim_21.7ebcc7fe.png";